import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Select, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import ninjaApi from 'store/redux/apis';

const PostbackSelect = ({ onChange, value, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [load, setLoad] = useState(20);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [getPostbacksQuery, { isFetching, data = [] }] = ninjaApi.useLazyListPostbacksQuery();
  const [selectedValue, setSelectedValue] = useState(null);
  const [loadingInitialOptions, setLoadingInitialOptions] = useState(false);

  const normalizedValue = useMemo(() => {
    return (value || []).map((v) => Number(v));
  }, [value]);

  useEffect(() => {
    const fetchInitialSelectedIds = async () => {
      if (!normalizedValue.length) return;
      try {
        setLoadingInitialOptions(true);
        await getPostbacksQuery({
          id: normalizedValue,
        }).unwrap();
      } catch (err) {
        console.error('Initial fetch failed', err);
      } finally {
        setLoadingInitialOptions(false);
      }
    };

    fetchInitialSelectedIds();
  }, []);

  const fetchPostbacks = useCallback(() => {
    getPostbacksQuery({ per_page: load }).unwrap();
  }, [getPostbacksQuery, load]);

  useEffect(() => {
    if (open || value) {
      fetchPostbacks();
    }
  }, [fetchPostbacks, open]);

  const handleChange = (value) => {
    onChange?.(value);
  };

  const handleClose = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (scrollPosition > 90 && !(load > data.length)) {
      setTimeout(() => {
        setLoad(load + 50);
      }, 200);
    }
  }, [scrollPosition]);

  return (
    <Select
      className='w-full'
      open={open}
      mode='multiple'
      maxTagCount='responsive'
      placeholder='Select a postback'
      loading={isFetching}
      value={loadingInitialOptions ? [] : normalizedValue}
      suffixIcon={loadingInitialOptions ? <LoadingOutlined /> : undefined}
      allowClear
      onChange={handleChange}
      onDropdownVisibleChange={handleClose}
      notFoundContent={
        isFetching && (
          <Spin indicator={<LoadingOutlined spin />} size='small' className='w-full m-auto' />
        )
      }
      onPopupScroll={(e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
        if (scrollPercentage > 90) {
          setScrollPosition(scrollPercentage);
        }
      }}
      {...rest}
    >
      {data?.data?.map((item) => (
        <Select.Option key={item.id} value={item.id}>
          {item.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default PostbackSelect;
